var React = require('react');

function Fi (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#002f6c","d":"M0 174.5h640v131H0z","key":1}),React.createElement("path",{"fill":"#002f6c","d":"M175.5 0h130.9v480h-131z","key":2})]);
}

Fi.defaultProps = {"id":"flag-icons-fi","viewBox":"0 0 640 480"};

module.exports = Fi;

Fi.default = Fi;
